import getSymbolFromCurrency from 'currency-symbol-map';

const CRYPTO_CURRENCY_SYMBOLS: Record<string, string> = {
  ADA: '₳',
  BCH: 'Ƀ',
  BNB: 'BNB',
  BSV: 'Ɓ',
  BTC: '₿',
  DOGE: 'Ð',
  EOS: 'ε',
  ETH: 'Ξ',
  LTC: 'Ł',
  TON: 'TON',
  TRX: 'TRX',
  USDC: 'USDC',
  USDT: '₮',
  XRP: '✕',
};

export const getCurrencySymbol = (currency: string): string | null => {
  if (!currency) {
    return null;
  }

  return (
    getSymbolFromCurrency(currency) ??
    CRYPTO_CURRENCY_SYMBOLS[currency.toUpperCase()] ??
    null
  );
};
